<template>
    <div class="preview-ewm">
        <div class="course-title">{{title}}</div>
        <div class="mt12 course-img">
            <vue-qr :text="qrText" :size="200"></vue-qr>
        </div>
        <div class="main-red font-16 text-c course-txt">请使用智谷APP扫码查看文章内容</div>
        <div class="box box-pack-end course-btn">
            <el-button type="primary" plain @click="doPass">审核通过</el-button>
            <el-button type="primary" plain @click="doFail">审核失败</el-button>
            <el-button type="danger" plain @click="closeDialog">取消</el-button>
        </div>
    </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
    name: 'audit-content',
    props: {
        title: {
            type: String,
            default: ''
        },
        qrText: {
            type: String,
            default: ''
        }
    },
    components: {
        VueQr
    },
    data() {
        return {

        }
    },
    watch: {
        qrText() {
            console.log('this.qrText', this.qrText)
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close')
        },
        doPass() {
            this.closeDialog();
            this.$emit('doPass')
        },
        doFail() {
            this.closeDialog();
            this.$emit('doFail')
        },
    }
}
</script>
<style lang="scss" scoped>
.course-img {
    width: 360px;
    margin: 0 auto 12px;
}

.course-btn {
    margin-top: 24px;
    margin-bottom: 24px;
    margin-right: 24px;
}
</style>